import { Component, OnInit, ViewChild, ViewChildren, Input, HostBinding, EventEmitter, Output , ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';
import { PlantingSiteAreaDto } from 'src/app/models/trofaco/plantingSiteAreaDto';
import { CustomerDto } from 'src/app/models/trofaco/customerDto';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PlantingSiteService } from 'src/app/modules/core/services/planting-site.service';
import { Subject } from 'rxjs';
import { BaseComponent } from 'src/app/modules/core/components/bases/base-component';
import { takeUntil } from 'rxjs/operators';

enum States {
    Add,
    Edit,
    Idle,
}
@Component({
    selector: ' tr [certificatesRow]',
    templateUrl: './certificates-row.component.html',
    styleUrls: ['./certificates-row.component.css']
})
export class CertificatesRowComponent extends BaseComponent implements OnInit, AfterViewInit{
    @Input()
    rowCertificate: CertificateDto = { isShow: true };

    original: CertificateDto = { isShow: true };

    @Input()
    certificates: CertificateDto[] = [];

    @Input()
    plantingSiteAreas: PlantingSiteAreaDto[] = [];

    @Input()
    misc: number;

    @Input()
    plantingSiteId: string;

    @Input()
    customers: CustomerDto[] = [];

    @Input()
    isEditRow: boolean;

    @Input()
    selectedAddCust: string;
    selectedPlantingSiteArea: string;

    @Input()
    placeholder: string;

    @Input()
    discardValues$ = new Subject<boolean>();

    @Input()
    showCustomerOnSite$ = new Subject<CertificateDto>();

    @Input()
    set newCustomer(newCus: CustomerDto) {
        if (newCus) {
            this.selectedAddCust = newCus.name;
            this.keepNewCustomerId = newCus.id;
        }
    }



    get max(): number {
        if (!this.original)  return;

        let count = this.original.count;
        let misc = this.remainMax;
        if (this.isEditRow) {
            return misc === 0 ? count : count + misc;
        } else {
            return misc;
        }
    }

    @Output()
    onSave = new EventEmitter<CertificateDto>();
    @Output()
    onDelete = new EventEmitter<CertificateDto>();
    @Output()
    onEditing = new EventEmitter<CertificateDto>();

    @ViewChild(NgForm, { static: true }) form: NgForm;
    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];
    @ViewChild(NgSelectComponent, { static: false }) selectNewCus: NgSelectComponent;

    @HostBinding('class.table-inline-edit-active')
    get showEditing() {
        return this.editing || !this.isEditRow;
    }

    editing = false;
    wasSubmitted = false;
    selectedEditCust: string;
    selectedEditAreaId: string;
    keepNewCustomerId: string;
    state: States;
    states = States;
    remainMax: number;

    constructor(private plantingSiteService: PlantingSiteService,
        private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.original = { ...this.rowCertificate };
        this.state = this.isEditRow ? this.states.Idle : this.states.Add;

        this.original = this.isEditRow ? { ...this.rowCertificate } : this.original = { isShow: true };
        this.rowCertificate = { ...this.rowCertificate };

        this.discardValues$
            .pipe( takeUntil(this.onDestroy$) )
            .subscribe((isFromEditRow) => {
                if (this.shouldDiscardChangesOnCreateRow(this.isEditRow, isFromEditRow)) {
                    this.rowCertificate = { isShow: true };
                    this.selectedAddCust = null;
                    this.selectNewCus.clearModel();
                    this.markClean();
                }else if (this.isEditRow){
                    this.revertChanges();
                }
        });

        this.showCustomerOnSite$.subscribe((cer) => {
            if (this.rowCertificate.customerId == cer.customerId) {
                this.rowCertificate.isShow = cer.isShow;
            }
        });

    }

    ngAfterViewInit(): void {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
        this.cdr.detectChanges();
        setTimeout(() => {
            this.checkLimitTrees(this.selectedEditAreaId);
          }, 1);
          setTimeout(() => {
            this.checkLimitTrees(this.selectedPlantingSiteArea);
          }, 1);
    }
    toggleShow(){
        if (this.isEditRow) return;

        this.rowCertificate.isShow = !this.rowCertificate.isShow;
    }

    async applyChanges() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }

        let custSelected = this.customers.find(val => val.id === this.selectedEditCust);
        if (custSelected) {
            this.rowCertificate.customerId = this.selectedEditCust;
            this.rowCertificate.customerName = custSelected.name;
        } else {
            custSelected = this.customers
                .find(val => val.name === this.rowCertificate.customerName);

            this.rowCertificate.customerId = custSelected.id;
        }

        let areaSelected = this.plantingSiteAreas.find(area => area.id == this.selectedEditAreaId);
        if(areaSelected) {
            this.rowCertificate.plantingSiteAreaId = areaSelected.id;
            this.rowCertificate.plantingSiteAreaName = areaSelected.name;
        }else {
            areaSelected = this.plantingSiteAreas.find(area => area.name == this.rowCertificate.plantingSiteAreaName);
            this.rowCertificate.plantingSiteAreaId = areaSelected.id;
        }

        let id = await this.plantingSiteService.updateCertificate(this.rowCertificate);
        this.showCustomerOnSite$.next(this.rowCertificate);

        // if update fail. app will not reach the lines below
        this.original = { ...this.rowCertificate };
        this.onEditing.emit(this.rowCertificate);

        if (id) {
            this.editing = false;
            this.state = this.states.Idle;
            this.markClean();
        }
        this.discardValues$.next(this.isEditRow);
    }

    revertChanges() {
        this.editing = false;
        this.state = this.states.Idle;
        this.rowCertificate = this.original;
        this.markClean();
    }

    openEdit() {
        this.discardValues$.next(this.isEditRow);
        this.selectedEditCust = this.rowCertificate.customerName;
        this.selectedEditAreaId = this.rowCertificate.plantingSiteAreaId;
        this.editing = true;
        this.state = this.states.Edit;
        this.original = { ...this.rowCertificate };
        this.rowCertificate = { ...this.rowCertificate };
    }

    openDelete() {
        this.discardValues$.next(this.isEditRow);
        this.original = { ...this.rowCertificate };
        this.onDelete.emit(this.rowCertificate);
    }

    async add() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }

        this.setCustomer();

        let newRowCertificate = await this.plantingSiteService.addCertificate(this.selectedPlantingSiteArea, this.rowCertificate);
        this.discardValues$.next(this.isEditRow);
        this.showCustomerOnSite$.next(this.rowCertificate);

        // if update fail. app will not reach the lines below
        this.rowCertificate.id = newRowCertificate.id;
        this.rowCertificate.code = newRowCertificate.code;
        this.onSave.emit({...this.rowCertificate});

        this.rowCertificate = { isShow: true };
        this.selectedAddCust = null;
        this.selectNewCus.clearModel();
        this.markClean();
    }

    markClean() {
        if (!this.isEditRow) this.original = { isShow: true };
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
        this.wasSubmitted = false;
    }

    @Output()
    modalCustomer = new EventEmitter<void>();
    showCustomer() {
        this.modalCustomer.emit();
    }

    private setCustomer(){
        let custSelected = this.customers.find(val => val.id === this.selectedAddCust);

        if (custSelected) {
            this.rowCertificate.customerName = custSelected.name;
            this.rowCertificate.customerId = this.selectedAddCust;
        } else {
            if (this.keepNewCustomerId) {
                custSelected = this.customers.find(val => val.id === this.keepNewCustomerId);
                this.rowCertificate.customerId = custSelected.id;
                this.rowCertificate.customerName = custSelected.name;
            }
        }

        let areaSelected = this.plantingSiteAreas.find(area => area.id === this.selectedPlantingSiteArea);
        if(areaSelected) {
            this.rowCertificate.plantingSiteAreaId = areaSelected.id;
            this.rowCertificate.plantingSiteAreaName = areaSelected.name;
        }
    }

    private shouldDiscardChangesOnCreateRow(isEditRow: boolean, isFromEditRow: boolean): boolean{
        return !isEditRow && isFromEditRow
    }
    checkLimitTrees(plantingSiteAreaId: any) {

        if (plantingSiteAreaId !== undefined) {
            const theArea = this.plantingSiteAreas.find(area => area.id == plantingSiteAreaId);

            let sumPlantingSiteArea = theArea.species.reduce((acc, cur) => acc + cur.count, 0);
            this.remainMax = sumPlantingSiteArea - theArea.certificates.reduce((acc, cur) => acc + cur.count, 0);
            }
    }
}
